export default __webpack_public_path__ + "static/media/t-shirts.0084ed6f.JPG";